import { CanDeactivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ReservationDetailTableComponent } from './reservation-detail-table.component';
import { ReservationCompareStore } from '../../service/reservation-compare-store';

@Injectable()
export class CanDeactiveReservationDetailTable implements CanDeactivate<ReservationDetailTableComponent> {

  constructor(private reservationCompareStore: ReservationCompareStore) {
  }

  canDeactivate(component: ReservationDetailTableComponent,
                currentRoute: ActivatedRouteSnapshot,
                currentState: RouterStateSnapshot,
                nextState?: RouterStateSnapshot): boolean {
    this.reservationCompareStore.setShowReservationCompareSummary(true);
    return true;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/reservation-detail-table/reservation-detail-can-deactive.ts